import { RegularEffect } from '../../../../../typings'
import { useGenericComponent } from '../../../../promotions/RegularForm/RegularEffect/hooks/useGenericComponent'
import { NeutralAlert } from '../NeutralAlert'
import { REVIEW_RECAP_MAP } from './constants'

type Props = {
  regular: RegularEffect
}

export function RegularRecap(props: Props) {
  const { regular } = props

  const { GenericComponent } = useGenericComponent({
    settings: REVIEW_RECAP_MAP,
    type: regular.benefit?.type,
  })

  if (!regular.benefit) return null

  return (
    <NeutralAlert>
      <GenericComponent config={regular} />
    </NeutralAlert>
  )
}
